import React from 'react';
import '../styles/Home.css';
import github from '../assets/images/github.png';
import mail from '../assets/images/mail.png';
import linkedin from '../assets/images/linkedin.png';
import youtube from '../assets/images/youtube.png';

const Home = () => {
    return (
        <div id='home' className='home'>
            <div className='title'>
                <h1>{"<"} hello world, <span>alexia</span> here {"/>"}</h1>
            </div>
            <div className='aboutme'>
                <p>
                    I’m driven by the process of creating — building systems from ideas, experimenting with new concepts, and refining them through iteration. For me, technology is more than writing code; it’s a way of understanding complexity and shaping it into something intentional and meaningful. I’m fascinated by how structure, logic, and discipline transform abstract ideas into functional systems, and as I approach graduation in Computer Science, I continue exploring software, data, and cybersecurity with curiosity and ambition.
                    <br /> <br />
                    Beyond code, I value documenting my journey and creative process. Creating, for me, is both technical and personal — it’s about experimenting, reflecting, and growing through experience. This portfolio is not just a collection of projects, but a record of evolution, discipline, and the commitment to continuously becoming better as an engineer and as a thinker.
                </p>
            </div>

            <div className='mysocials'>
                <a href='https://github.com/aleedca' target='_blank' rel='noreferrer'><img src={github} alt='github' /></a>
                <a href='https://www.linkedin.com/in/alexiacerdas/' target='_blank' rel='noreferrer'><img src={linkedin} alt='linkedin' /></a>
                <a href='https://www.youtube.com/@aleedca' target='_blank' rel='noreferrer'><img src={youtube} alt='linkedin' /></a>
                <a href='mailto:acerdas1701@gmail.com'><img src={mail} alt='mail' /></a>
            </div>

            {/*
                <a href={resume} download="Resume_AlexiaCerdas" target='_blank' rel="noreferrer">
                    <button className='button'>Download CV</button> 
                </a>
                */}
        </div>
    );
}

export default Home;